import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import API from "@src/API.js";
import CustomButton from "@src/components/Controls/CustomButton";
import { useMarketingAuthUi } from "../MarketingAuthUi";

function validationMessage(payload, fallback) {
  if (!payload) return fallback;
  if (typeof payload === "string") return payload;
  return payload.error || payload.message || payload.msg || fallback;
}

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code") || "";
  const { openLogin } = useMarketingAuthUi();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("Verifying your email…");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!code) {
        setStatus("error");
        setMessage("Missing verification code.");
        return;
      }
      try {
        const resp = await API.postAsync("/VerifyEmail", { code });
        if (cancelled) return;
        if (resp && resp.ok) {
          setStatus("ok");
          setMessage("Email verified. You can sign in now.");
          toast.success("Email verified");
        } else {
          const msg = validationMessage(
            resp?.jsonData,
            "This verification link is invalid or has expired."
          );
          setStatus("error");
          setMessage(msg);
          toast.error(msg);
        }
      } catch (e) {
        if (cancelled) return;
        setStatus("error");
        setMessage(e?.message || "Verification failed");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <article className="mkt-page">
      <header className="mkt-hero">
        <h1>Email verification</h1>
        <p data-testid="verify-email-status">{message}</p>
      </header>
      {status === "ok" && (
        <section className="mkt-section">
          <CustomButton
            type="button"
            variant="contained"
            color="primary"
            onClick={() => openLogin()}
          >
            Log in
          </CustomButton>
        </section>
      )}
      {status === "error" && (
        <section className="mkt-section">
          <p>
            <Link to="/">Return home</Link>
            {" · "}
            <Link to="/contact">Contact support</Link>
          </p>
        </section>
      )}
    </article>
  );
}
